import { render } from "./ProjectsItem.vue?vue&type=template&id=625055d0&scoped=true"
import script from "./ProjectsItem.vue?vue&type=script&lang=js"
export * from "./ProjectsItem.vue?vue&type=script&lang=js"

import "./ProjectsItem.vue?vue&type=style&index=0&id=625055d0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625055d0"]])

export default __exports__